import React, { Component } from "react";
import styles from "./detailBonusStates.module.scss";
import { BonusCardModel } from "../bonusCard/model";
import Spinner from "../../spinner";
import { Popup } from "semantic-ui-react";
import { sendMetrics } from "../../../utils/misc";

export default class BonusesOpened extends Component {
  props: {
    info: BonusCardModel;
  };
  input: HTMLInputElement;
  state: {
    openedConfines: boolean;
    copied: boolean;
  };
  private copiedTimeout: NodeJS.Timeout;

  constructor(props) {
    super(props);
    this.state = {
      openedConfines: false,
      copied: false,
    };
  }

  getConfines = (confines): string | undefined | JSX.Element => {
    if (confines?.length > 64) {
      if (this.state.openedConfines) {
        return confines;
      }
      return (
        <ShortConfines
          confines={`${confines.slice(0, 64)}... `}
          openedConfines={this.openConfines}
        />
      );
    }
    return confines;
  };

  openConfines = (): void => {
    this.setState({
      openedConfines: true,
    });
  };

  copyPromo = (): void => {
    sendMetrics("copy_button");
    const el = this.input;
    el.select();
    document.execCommand("copy");
    this.setState({
      copied: true,
    });
    this.copiedTimeout = setTimeout(() => {
      this.setState({
        copied: false,
      });
    }, 2000);
  };

  componentWillUnmount() {
    clearTimeout(this.copiedTimeout);
  }

  render() {
    const { info } = this.props;
    const { copied } = this.state;

    if (info)
      return (
        <div className={styles.BonusesOpened}>
          <div className={styles.BonusesOpenedTooltip}>
            <span>Ваш промокод</span>
            <Popup
              className={styles.Popups}
              inverted
              basic
              style={{ backgroundColor: "#333333" }}
              position={"left center"}
              trigger={
                <img src="/static/images/icons/bonusTooltip.svg" alt="" />
              }
            >
              Бонус можно использовать, пока не истечёт его срок действия. Затем
              он пропадет.
            </Popup>
          </div>
          <div className={styles.BonusesOpenedPromo}>
            {!copied && (
              <div className={styles.BonusesOpenedPromoNoDone}>
                <input
                  type={"text"}
                  readOnly
                  ref={(input) => (this.input = input)}
                  value={info?.promocode}
                />
                <div>
                  <img
                    onClick={this.copyPromo}
                    src="/static/images/icons/copyBonusPromo.svg"
                    alt=""
                  />
                </div>
              </div>
            )}
            {copied && (
              <div className={styles.BonusesOpenedPromoDone}>
                <span>Промокод скопирован</span>
                <img src="/static/images/icons/copyDoneBonusPromo.svg" alt="" />
              </div>
            )}
          </div>
          <div className={styles.BonusesOpenedConfines}>
            <span>{this.getConfines(info.bonusConfines)}</span>
          </div>
          <div
            className={`${styles.BonusesOpenedLink} ${info.isExpired && styles.BonusesOpenedLinkExpired}`}
            onClick={() => sendMetrics("to_taken_bonus_partner")}
          >
            <a target={"_blank"} href={info?.partnerUrl}>
              Перейти на сайт партнера
            </a>
          </div>
        </div>
      );
    else return <Spinner toggled={true} />;
  }
}

const ShortConfines = ({ openedConfines, confines }) => {
  return (
    <span>
      {confines}
      <span
        onClick={openedConfines}
        className={styles.BonusesOpenedConfinesOpen}
      >
        все условия
      </span>
    </span>
  );
};
